<dialog qai-dialog [heading]="title()" [roundedClose]="true" (afterClose)="onAfterClose()">
  <div class="container">
    <qai-tabs>
      @for (tab of sortedTabs(); track tab.tabTitle) {
      <ng-template [qaiTab]="tab.tabTitle" [label]="tab.tabTitle">
        <div class="tab-content" [innerHTML]="processTabText(tab.tabText)"></div>
      </ng-template>
      }
    </qai-tabs>
  </div>
</dialog>